import { useQuery } from "@apollo/client";
import LanguageShowQuery from "../graphql/queries/LanguageShowQuery.graphql";
import LanguageEditQuery from "../graphql/queries/LanguageEditQuery.graphql";
import type {
  LanguageShowQueryType,
  LanguageEditQueryType,
} from "@/types/graphql/admin.generated";

export function useLanguageShowQuery(id: string | null, skip = false) {
  return useQuery<LanguageShowQueryType>(LanguageShowQuery, {
    variables: { id },
    skip: skip || !id,
  });
}

export function useLanguageEditQuery(id: string | null, skip = false) {
  return useQuery<LanguageEditQueryType>(LanguageEditQuery, {
    variables: { id },
    skip: skip || !id,
  });
}
